import { useEffect, useState, useTransition } from "react"
import { ModuleEnum, useLazyGetUtilitiesQuery } from "src/api/modules/utilitize"
import InputAutocomplete from "src/shared/components/input-autocomplete"

interface SelectPortFieldProps {
  value: string
  onChange: (value: string, valueObj: any) => void
  label?: string
  fullWidth?: boolean
  placeholder?: string
  required?: boolean
  helperText?: string
  error?: boolean
  disableClearable?: boolean
}

const SelectPortField = ({
  value,
  onChange,
  label,
  placeholder,
  fullWidth = true,
  required = false,
  helperText,
  disableClearable = false,
  error
}: SelectPortFieldProps) => {
  const [isPortPending, startPortTransition] = useTransition()
  const [port, setPort] = useState<IOptions[]>([])

  const [getUtilities] = useLazyGetUtilitiesQuery()
  const handleGetPort = async () => {
    startPortTransition(async () => {
      const response = await getUtilities({
        page: 1,
        limit: 10000,
        active: true,
        module: ModuleEnum.PORT
      })
      startPortTransition(() => {
        setPort(
          response.data?.data?.map(item => ({
            value: item.id ?? "",
            label: item.itemName ?? ""
          })) ?? []
        )
      })
    })
  }

  useEffect(() => {
    if (value && !port.length) {
      handleGetPort()
    }
  }, [value])

  return (
    <InputAutocomplete
      label={label}
      loading={isPortPending}
      fullWidth={fullWidth}
      loadingText="Loading Port..."
      options={port}
      getOptionLabel={item => item.label ?? ""}
      getOptionKey={item => item.value ?? ""}
      onOpen={() => !port.length && handleGetPort()}
      value={port.find(item => item.value === value)}
      placeholder={placeholder}
      onChange={(value: any) => {
        onChange(value?.value, value)
      }}
      required={required}
      helperText={helperText}
      error={error}
      disableClearable={disableClearable}
    />
  )
}

export default SelectPortField
